import { LayerData } from "../../utils/brickOptimizer";

export const exportInstructions = (layers: LayerData[]) => {
  const instructions = layers.map((layer) => ({
    layer: layer.layer + 1,
    brickCount: layer.bricks.length,
    bricks: layer.bricks.map((brick) => ({
      position: `(${brick.x + 1}, ${brick.y + 1})`,
      size: `${brick.brickType.width}x${brick.brickType.height}`,
      color: brick.colorName,
      type: brick.brickType.name,
      rotation: brick.rotation,
    })),
  }));

  const dataStr = JSON.stringify(instructions, null, 2);
  const dataUri =
    "data:application/json;charset=utf-8," + encodeURIComponent(dataStr);

  const exportFileDefaultName = "lego-instructions.json";

  const linkElement = document.createElement("a");
  linkElement.setAttribute("href", dataUri);
  linkElement.setAttribute("download", exportFileDefaultName);
  linkElement.click();
};
